import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ImageIcon from 'mdi-react/ImageIcon';
import VideoIcon from 'mdi-react/PlayCircleOutlineIcon';

import ProductMediaLightbox from '../product-media-lightbox';
import MediaCounter from './media-counter';

import { productMediaOpen } from '../../actions/media';

import { trackProductMediaOpened } from './tracking';

import { Media } from './types';

import * as S from './styles';

type Props = {
  category?: {
    logo?: string | null;
  } | null;
  className?: string;
  media: Media;
  name: string;
};

export const ProductMedia = (props: Props) => {
  const { category, className, media, name } = props;

  const [show, setShow] = useState<boolean>(false);

  const dispatch = useDispatch();

  const hasLightboxContent = () => {
    return Boolean(media.large?.length || media.videos?.length);
  };

  const open = () => {
    if (!hasLightboxContent()) {
      return;
    }

    trackProductMediaOpened();

    setShow(true);
    dispatch(productMediaOpen());
  };

  const close = () => setShow(false);

  return (
    <>
      {show && <ProductMediaLightbox media={media} close={close} />}
      <S.ProductMedia
        className={className}
        onClick={open}
        data-test="ProductMedia"
        data-test-has-lightbox-content={hasLightboxContent()}
        $isFallbackImage={!media.first}
        $more={Boolean(media && media.images)}
      >
        <S.FirstImage>
          <img src={media.first || category?.logo || undefined} alt={name} />
        </S.FirstImage>
        {(media.images || media.videos) && (
          <S.Counters>
            <MediaCounter icon={ImageIcon} mediaList={media.images} />
            <MediaCounter icon={VideoIcon} mediaList={media.videos} />
          </S.Counters>
        )}
      </S.ProductMedia>
    </>
  );
};
